export { default } from './AccordionSummary';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/AccordionSummary/index.js
// module id = 304
// module chunks = 0